<template>
  <article class="project project-css">
    <div
      role="presentation"
      class="d-project__background"
      :class="background"
    ></div>
    <main class="project-css__main padded">
      <section class="project-about project-section project-css__section">
        <h1>CSS Art</h1>
      </section>
      <section class="project-section project-css__section  swatches">
        <p>Background:</p>
        <input
          type="radio"
          name="background"
          id="wavy"
          value="wavy"
          v-model="background"
        />
        <label for="wavy"> </label>
        <input
          type="radio"
          name="background"
          id="dots"
          value="dots"
          v-model="background"
        />
        <label for="dots"> </label>
        <input
          type="radio"
          name="background"
          id="triangles"
          value="triangles"
          v-model="background"
        />
        <label for="triangles"> </label>
      </section>
      <section class=" project-section project-css__section figure-links">
        <a
          v-for="sample in samples"
          :key="sample.caption"
          :href="sample.link"
          target="_blank"
          rel="noopener noreferrer"
          :style="{
            backgroundImage: `linear-gradient(${sample.color},${sample.color} )`
          }"
          class="figure-links__figure"
        >
          <img src="/assets/images/icons/link.svg" class="external-link" />
          <figure>
            <img :src="sample.src" :alt="sample.alt" />
            <figcaption
              class="figure-links__caption text-smaller text_align_center"
            >
              {{ sample.caption }}
            </figcaption>
          </figure>
        </a>
      </section>
      <section class="project-css__section">
        <p>
          More on
          <a
            href="https://codepen.io/collection/nbQOZv"
            target="_blank"
            rel="noopener noreferrer"
            >Codepen</a
          >
        </p>
      </section>
      <section class="project-css__section">
        <p>
          In case you are interested in learning CSS Art, I wrote an article on
          <a
            class="text"
            href="https://dev.to/poulamic/intro-to-creating-css-art-1ep5"
            target="_blank"
            rel="noopener noreferrer"
            >introduction to CSS Art
          </a>
        </p>
      </section>
    </main>
  </article>
</template>

<script>
import { CSSArtSamples } from '@/contents/contents.js'
export default {
  data() {
    return {
      background: 'wavy',
      samples: CSSArtSamples
    }
  },
  mounted: function() {}
}
</script>

<style scoped>
.project-css {
  min-height: 100%;
}
.project-css__section {
  padding: var(--padding-sm);
}
.figure-links {
  width: 90%;
  margin: auto;
  text-align: center;
  text-decoration: dotted;
}
.figure-links__figure {
  display: block;
  text-decoration: none;
  padding: 0;
  margin-bottom: var(--padding-sm);
  background-size: 100% 50%;
  background-position: 0 0;
  background-repeat: no-repeat;
  position: relative;
  transition: background-size 0.3s ease-in-out;
}
.figure-links__figure:hover {
  background-size: 100% 100%;
}
.figure-links__caption {
  margin-bottom: 0;
  position: relative;
  padding-bottom: var(--padding-sm);
}

.figure-links__figure:hover .figure-links__caption {
  background: inherit;
}
.figure-links__figure .external-link {
  z-index: 1;
  top: var(--padding-sm);
}
.figure-links__figure:hover .external-link {
  right: var(--padding-sm);
  opacity: 1;
  animation: fade-slide 0.6s ease-in-out;
}

.d-project__background {
  position: absolute;
  width: 100%;
  height: 100%;
  transition: background 0.1s ease-in-out;
}

input,
input[type='radio'],
label,
input[type='radio']:checked + label {
  all: unset;
}
label[for='wavy'],
input[type='radio']:checked + label[for='wavy'],
.d-project__background.wavy {
  background-image: radial-gradient(
      circle at 100% 100%,
      rgb(255, 255, 255) 10%,
      rgb(0, 0, 0) 10%,
      rgb(0, 0, 0) 20%,
      rgb(255, 255, 255) 20%,
      rgb(255, 255, 255) 30%,
      rgb(0, 0, 0) 30%,
      rgb(0, 0, 0) 40%,
      rgb(255, 255, 255) 40%,
      rgb(255, 255, 255) 50%,
      rgb(0, 0, 0) 50%,
      rgb(0, 0, 0) 60%,
      rgba(0, 0, 0, 0) 60%
    ),
    radial-gradient(
      circle at 0px 0px,
      rgba(0, 0, 0, 0) 10%,
      rgb(0, 0, 0) 10%,
      rgb(0, 0, 0) 20%,
      rgba(0, 0, 0, 0) 20%,
      rgba(0, 0, 0, 0) 30%,
      rgb(0, 0, 0) 30%,
      rgb(0, 0, 0) 40%,
      rgba(0, 0, 0, 0) 40%,
      rgba(0, 0, 0, 0) 50%,
      rgb(0, 0, 0) 50%,
      rgb(0, 0, 0) 60%,
      rgba(0, 0, 0, 0) 60%,
      rgba(0, 0, 0, 0) 70%,
      rgb(0, 0, 0) 70%,
      rgb(0, 0, 0) 80%,
      rgba(0, 0, 0, 0) 80%
    );
  background-size: 4rem 4rem, 4rem 4rem;
  background-position: 0% 0%, 0% 0%;
  background-color: var(--bg-color);
}
label[for='dots'],
input[type='radio']:checked + label[for='dots'],
.d-project__background.dots {
  background-image: radial-gradient(
      var(--primary-color) 25%,
      rgba(0, 0, 0, 0) 26%
    ),
    radial-gradient(var(--primary-color) 16%, rgba(0, 0, 0, 0) 17%);
  background-size: 40px 40px, 40px 40px;
  background-position: 0px 0px, 20px 20px;
  background-color: rgb(255, 255, 255);
}
label[for='triangles'],
input[type='radio']:checked + label[for='triangles'],
.d-project__background.triangles {
  background-image: linear-gradient(
      120deg,
      rgba(0, 0, 0, 0) 75%,
      rgb(0, 0, 0) 75%
    ),
    linear-gradient(240deg, rgba(0, 0, 0, 0) 75%, rgb(0, 0, 0) 75%),
    linear-gradient(120deg, rgba(0, 0, 0, 0) 75%, rgb(0, 0, 0) 75%),
    linear-gradient(240deg, rgba(0, 0, 0, 0) 75%, rgb(0, 0, 0) 75%);
  background-size: 2rem 3.24rem, 2rem 3.24rem, 2rem 3.24rem, 2rem 3.24rem;
  background-position: 0% 0%, 0% 0%, 1rem -1.62rem, 1rem 1.62rem;
  background-color: var(--bg-color);
}
.d-project__background::after {
  content: '';
  position: absolute;
  width: calc(99.6vw - 3.2rem);
  height: calc(100% - 3.2rem);
  top: var(--padding-sm);
  left: var(--padding-sm);
  background: var(--bg-color);
  opacity: 0.98;
}

input[type='radio']:checked + label,
label {
  display: inline-block;
  height: 2.4rem;
  width: 4rem;
  outline: 0.1rem solid var(--primary-color);
  transition: outline 0.1s ease-in;
}
label[for='wavy'],
input[type='radio']:checked + label[for='wavy'] {
  background-size: 1.2rem 1.2rem, 1.2rem 1.2rem;
}
label[for='dots'],
input[type='radio']:checked + label[for='dots'] {
  background-size: 1.2rem 1.2rem, 1.2rem 1.2rem;
  background-position: 0 0, 0.6rem 0.6rem;
}
label[for='triangles'],
input[type='radio']:checked + label[for='triangles'] {
  background-size: 1rem 1.62rem, 1rem 1.62rem, 1rem 1.62rem, 1rem 1.62rem;
  background-position: 0% 0%, 0% 0%, 0.5rem -0.81rem, 0.5rem 0.81rem;
}
input[type='radio']:checked + label {
  outline: 0.4rem solid var(--primary-color);
}
.swatches {
  display: flex;
  align-items: center;
}
.swatches p {
  margin-right: 1.2rem;
}
.swatches label,
.swatches input[type='radio']:checked + label {
  margin-left: 1.2rem;
}
@media only screen and (min-width: 60rem) {
  .figure-links {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1.2rem;
  }
}
</style>
